import CrmService from "services/CrmService";
import ReportsService from "services/ReportsService";
import SharedService from "services/SharedService";
import UserService from "services/UserService";
import AuthService from "services/AuthService";

export {
  CrmService,
  ReportsService,
  SharedService,
  UserService,
  AuthService,
};
